import useItem from './useItem'

const useItemWithoutTotal = () => {
  const { data, loading } = useItem()
  return {
    data: data?.filter(({ itemName }) => itemName !== 'TOTAL'),
    loading,
  }
}

export default useItemWithoutTotal
